import React from 'react'
import { Row, Col } from 'react-bootstrap'

const tableHeaderStyles = {
  row: {
    padding: '4px 16px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  col: (align = 'center') => ({
    padding: 0,
    display: 'flex',
    justifyContent: align,
  }),
  contentWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  iconWrapper: {
    marginRight: 8,
    height: 25,
  },
  label: {
    color: '#707087',
    fontSize: 14,
    fontWeight: 700,
  },
}

const TableHeader = ({ data }) => {
  return (
    <Row style={tableHeaderStyles.row}>
      {data.map(item => (
        <Col xs={item.xs} style={tableHeaderStyles.col(item.align)}>
          <div style={tableHeaderStyles.contentWrapper}>
            <div style={tableHeaderStyles.iconWrapper}>{item.icon}</div>
            <div style={tableHeaderStyles.label}>{item.label}</div>
          </div>
        </Col>
      ))}
    </Row>
  )
}

export default TableHeader
